<template>
  <div v-if="show">
    <div style="padding-bottom:0.35rem;">
      <span class="us_block_title">拓扑图设备</span>
    </div>
    <LoadingText v-if="loading" />
    <div v-else>
      <div v-for="(item,index) in list" :key="'on'+index" style="background:#fff;" >
        <DeviceCard :dev-info="item" :dev-prop="item.prop" :idx=" index + 1 " :off-line="item.SECURER_SID !=2" flat />
      </div>
      <div v-if="list.length === 0 && !loading" style="text-align:center;background:#fff;padding:1rem 0;">
        <div style="font-size:0.8rem;color:#9e9e9e;">暂无拓扑图设备</div>
      </div>
      <div style="margin:1rem 0;"></div>
    </div>
  </div>
</template>

<script>
import DeviceCard from './DeviceCard'
import LoadingText from '../../../components/LoadingText'
export default {
  components: {
    DeviceCard,
    LoadingText
  },
  props: {
  },
  data() {
    return {
      list: [],
      loading: true,
      timeout: null,
      show: false
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.getList()
  },
  destroyed() {
    var that = this
    if (that.timeout) {
      window.clearTimeout(that.timeout)
    }
  },
  activated() {
  },
  deactivated() {
    var that = this
    if (that.timeout) {
      window.clearTimeout(that.timeout)
    }
  },
  methods: {
    async getList() {
      var that = this
      await that.$api.flow.get_flow_device({}).then(res => {
        console.log('get_flow_device', res);
        if (!res.success) {
          that.loading = false
          that.list = []
          that.show = false
          console.log('获取设备列表失败', res);
          // that.$toast.error('获取设备列表失败')
          return
        }
        var data = res.data
        that.list = data
        that.loading = false
        that.show = true
      })
    }
  }
}
</script>

<style scoped>
.us_block_title{
  font-weight:bold;
  font-size:1.05rem;
  color: rgba(33,33,33,0.9);
}
.us_block_more_text{
  font-size:0.8rem;
  padding-top:0.3rem;
  padding-right:0.4rem;
  float:right;
  color:#9e9e9e;
  cursor: pointer;
}
.us_block_more_text span{
  font-size:0.8rem;
}
.us_block_more_text i{
  margin-left:0.4rem;
}
</style>
